import React from 'react';
import { Router, Location } from '@reach/router';
import Header from './Headers/Header';
import Footer from './Footers/Footer';
import Page from './Page';
import TAGThemeProvider from './TAGThemeProvider';

var App = function App(_ref) {
  var children = _ref.children,
      contentfulData = _ref.contentfulData;
  var branding = contentfulData.branding,
      pages = contentfulData.pages;
  return React.createElement(TAGThemeProvider, {
    branding: branding
  }, React.createElement(Header, {
    contentfulData: contentfulData
  }), pages && React.createElement(Location, null, function (_ref2) {
    var location = _ref2.location;
    return React.createElement(Router, {
      location: location
    }, pages.map(function (page) {
      return React.createElement(Page, {
        key: page.path,
        path: page.path,
        branding: branding,
        pageData: page
      });
    }));
  }), children, React.createElement(Footer, {
    contentfulData: contentfulData
  }));
};

export default App;